import { Typography } from "@mui/material";

const SectionHeader = ({ title, color }: { title: string; color: string }) => (
  <Typography
    variant="caption"
    sx={{
      fontWeight: 700,
      color,
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      fontSize: "0.7rem",
      display: "block",
      mb: 2,
    }}
  >
    {title}
  </Typography>
);

export default SectionHeader;